module.exports = "<a href=\"#\" class=\"logo\">\n  <img src=\"assets/logo/logo-white.png\" alt=\"logo\"  height=\"60\" class=\"logo-img\">\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/logo/logo.component.html
// module id = ./src/app/Dashboard/logo/logo.component.html
// module chunks = main